"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.animation = {
    durationBase: '0.0s',
    durationSlow: '0.0s',
    durationFast: '0.0s'
};
//# sourceMappingURL=animation.js.map